import {
  SlProgressBar
} from "./chunk.QZUNWYBQ.js";
import {
  progress_bar_styles_default
} from "./chunk.JQ6TDOGG.js";
import {
  i
} from "./chunk.LP7FQRAP.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/progress-bar/progress-bar.ts
import { t } from "i18next";
var FadvProgressBar = class extends SlProgressBar {
  constructor() {
    super(...arguments);
    this.variant = "primary";
  }
  render() {
    return $`<div part="base" class=${o({
      "progress-bar": true,
      "progress-bar--primary": this.variant === "primary",
      "progress-bar--secondary": this.variant === "secondary",
      "progress-bar--tertiary": this.variant === "tertiary",
      "progress-bar--success": this.variant === "success",
      "progress-bar--neutral": this.variant === "neutral",
      "progress-bar--warning": this.variant === "warning",
      "progress-bar--danger": this.variant === "danger",
      "progress-bar--indeterminate": this.indeterminate,
      "progress-bar--processing": this.processing,
      "progress-bar--animated": this.processing && this.animated
    })} role="progressbar" aria-label=${this.label || t("components:common.progress")} aria-valuemin="0" aria-valuemax="100" aria-valuenow="${this.indeterminate ? "" : this.value}" ><div class="progress-bar__track"></div><div part="indicator" class="progress-bar__indicator" style=${i({ width: `${this.value}%` })}>${!this.indeterminate ? $`<span part="label" class="progress-bar__label"><slot></slot></span>` : w}</div></div>`;
  }
};
FadvProgressBar.styles = progress_bar_styles_default;
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvProgressBar.prototype, "animated", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvProgressBar.prototype, "processing", 2);
__decorateClass([
  e({ reflect: true })
], FadvProgressBar.prototype, "variant", 2);
FadvProgressBar = __decorateClass([
  n("fadv-progress-bar")
], FadvProgressBar);

export {
  FadvProgressBar
};
